/* src/app/components/planestratamiento/dienteselector/dienteselector.component.scss */
.boca-left {
  border-right: 1px solid #000000;
}
.boca-bottom {
  padding-top: 10px;
}
.boca-top {
  border-bottom: 1px solid #000000;
  padding-bottom: 10px;
}
/*# sourceMappingURL=dienteselector.component.css.map */
